import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
// import { FantasyTipsIcon } from '../../ctIcons'
// import tossIcon from '@assets/images/icon/toss-icon.svg'

import Slider from '@shared/components/slider'
// import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
// import { useRouter } from 'next/router'
// import CustomLink from '@shared/components/customLink'

const SingleFantasyLeague = dynamic(() => import('../singleFantasyLeague'))
// const MyImage = dynamic(() => import('@shared/components/myImage'))

const FantasyTeam = ({ teamData = [], matchData, isBtn, updatedTime, type }) => {
  const [selectedTab, setSelectedTab] = useState(teamData?.[0]?.eLeague)
  // const router = useRouter()

  const handleTab = value => {
    setSelectedTab(value)
  }
  // const handleEvent = (id) => {
  //   if (router?.query?.isMobileWebView) {
  //     sendMobileWebViewEvent(`matchPredictionId:${id}`)
  //   }
  // }
  useEffect(() => {
    teamData && setSelectedTab(teamData[0]?.eLeague)
  }, [teamData])
  return (
    <>
      <h6 className="font-bold d-none d-md-block mt-1">{'Top team pick'}</h6>
      <section className={`${styles.container} pt-2 pt-md-2 mb-4`} id="team">
        <div className={`${styles.fantasyTeam}`}>
          {/* <div className={`${styles.toss} p-2 mb-2`}>
          <div className="d-flex align-items-center">
            {matchData?.sStatusStr === 'scheduled' && <span className={`${styles.icon} me-2`}>
              <MyImage src={tossIcon} alt="user" layout="responsive" width="40" height="40" />
            </span>}
            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between flex-grow-1">
              {matchData?.sStatusStr === 'scheduled' && <p className="d-flex align-items-center mb-0">{"Teams will be updated after Toss"}</p>}
              <p className="mb-0 text-muted">
                {"Last updated on"} {updatedTime && ' - ' + convertDateAMPM(updatedTime)}
              </p>
            </div>
          </div>
        </div> */}
          <div className="d-flex flex-column flex-md-row w-100 align-items-center justify-content-md-between justify-content-center mb-2 mb-md-2 px-2">
            <Nav variant="pills" className={`${styles.navTab} flex-nowrap my-0 text-nowrap me-0 w-100 equal-width-nav`}>
              {teamData?.map((league, index) => {
                return (
                  <Nav.Item key={index}>
                    <Nav.Link
                      onClick={() => handleTab(league?.eLeague)}
                      className={`${styles.tab} nav-link ${selectedTab === league?.eLeague && styles.active}`}>
                      {league?.eLeagueFull}
                    </Nav.Link>
                  </Nav.Item>
                )
              })}
            </Nav>
          </div>
          <div className={`${styles.teamSlider} fantasy-team-slider simple-arrow`}>
            <Slider nav gap={0} destroyBelow={1199}>
              {teamData?.map((team, indexI) => {
                return (
                  team?.eLeague === selectedTab &&
                  team?.aTeam?.map((fantasyTeam, indexJ) => {
                    return (
                      <SingleFantasyLeague
                        styles={styles}
                        key={indexI + indexJ}
                        indexJ={indexJ}
                        data={fantasyTeam}
                        type={type}
                        teamAID={matchData?.oTeamA?._id}
                      />
                    )
                  })
                )
              })}
            </Slider>
          </div>
          {/* {!isBtn && (
          <p className={`${styles.predictions} font-bold small-text text-end`} onClick={() => handleEvent(matchData?._id)}>
            <CustomLink href={allRoutes.matchDetailFantasyTips(`/${matchData?.oSeo?.sSlug}/`)} prefetch={false}>
              <a className="d-flex justify-content-end align-items-center" style={router?.query?.isMobileWebView && { pointerEvents: 'none' }}>
                <FantasyTipsIcon /> {"More Predictions"}
              </a>
            </CustomLink>
          </p>
        )} */}
        </div>
      </section>
    </>
  )
}

FantasyTeam.propTypes = {
  fantasystyles: PropTypes.any,
  teamData: PropTypes.array,
  matchData: PropTypes.object,
  isBtn: PropTypes.bool,
  playerData: PropTypes.array,
  updatedTime: PropTypes.any,
  type: PropTypes.string
}

export default FantasyTeam
